<template>
	<div class="tab-text">
		<h3 class="">Crowd Reviews</h3>
		<div class="vx-row">
			<div
				class="vx-col w-full lg:w-1/2 sm:w-1/1"
				style="height: 330px; overflow: hidden"
			>
				<vue-apex-charts
					type="radar"
					height="360"
					style="margin-top: -20px"
					:options="radarChart.chartOptions"
					:series="radarChartSeries"
				></vue-apex-charts>
				<template>
					<vue-apex-charts
						type="radar"
						height="300"
						:options="radarChart.chartOptions"
						:series="radarChartSeries"
					></vue-apex-charts>
				</template>
				<!-- <template slot="codeContainer" style="height: auto !important">
					{{ apexChatData.radarChartCode }}
				</template> -->
			</div>
			<div class="vx-col w-full lg:w-1/2 sm:w-1/1">
				<vx-card class="">
					<vs-dropdown class="mb-4">
						<h5>
							Service
							<vs-icon class="" icon="expand_more"></vs-icon>
						</h5>
						<vs-dropdown-menu>
							<vs-dropdown-item> Service </vs-dropdown-item>
							<vs-dropdown-item class="whitespace-no-wrap">
								Food and Beverage
							</vs-dropdown-item>
							<vs-dropdown-item class="whitespace-no-wrap">
								Cabins
							</vs-dropdown-item>
							<vs-dropdown-item class="whitespace-no-wrap">
								Onboard Facilities
							</vs-dropdown-item>
							<vs-dropdown-item class="whitespace-no-wrap">
								Wifi
							</vs-dropdown-item>
							<vs-dropdown-item class="whitespace-no-wrap">
								Entertainment
							</vs-dropdown-item>
							<vs-dropdown-item class="whitespace-no-wrap">
								Onboard Activities
							</vs-dropdown-item>
							<vs-dropdown-item class="whitespace-no-wrap">
								Shore Excursions
							</vs-dropdown-item>
							<vs-dropdown-item class="whitespace-no-wrap">
								Value for Money
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>

					<div
						class="border-t border-l-0 border-r-0 border-b-0 d-theme-border-grey-light border-solid pt-4"
					>
						<div
							class="flex items-center text-sm justify-between mb-4"
							v-for="top in tops"
							:key="top.label"
						>
							<div class="flex items-center">
								<feather-icon
									svgClasses="h-4 w-4 stroke-current NOTtext-primary"
									icon="PlusCircleIcon"
									class="mr-1"
								/>
								<span>{{ top.label }}</span>
								&nbsp;
								<span class="text-sm text-grey"
									>({{ top.reviews }} reviews)</span
								>
							</div>

							<vs-progress
								:percent="top.score * 100"
								color="#2de071"
								style="width: 33%"
							/>
						</div>
					</div>
					<div
						class="border-t border-l-0 border-r-0 border-b-0 d-theme-border-grey-light border-solid pt-4"
					>
						<div
							class="flex items-center text-sm justify-between mb-4"
							v-for="flop in flops.reverse()"
							:key="flop.label"
						>
							<div class="flex items-center">
								<feather-icon
									svgClasses="h-4 w-4 stroke-current NOTtext-primary"
									icon="MinusCircleIcon"
									class="mr-1"
								/>
								<span>{{ flop.label }}</span>
								&nbsp;
								<span class="text-sm text-grey">
									({{ flop.reviews }} reviews)</span
								>
							</div>

							<vs-progress
								:percent="flop.score * 100"
								color="primary"
								style="width: 33%"
							/>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
// import apexChatData from '../../views/apexChartData.js'

export default {
	data() {
		return {
			radarChart: {
				chart: {
					stacked: false,
					toolbar: {
						show: false,
					},
				},
				series: [
					{
						name: "Crowd Scoring",
						data: [],
					},
				],
				chartOptions: {
					colors: ["#e44a7f", "#626262", "#EA5455", "#FF9F43", "#1E1E1E"],
					labels: [
						"Service",
						"Food and Beverage",
						"Cabins",
						"Onboard Facilities",
						"Wifi",
						"Entertainment",
						"Onboard Activities",
						"Shore Excursions",
						"Value for Money",
					],
					yaxis: {
						min: 0,
						max: 100,
						tickAmount: 5,
					},
				},
			},
		};
	},
	components: {
		VueApexCharts,
	},
	props: {
		result: {
			type: Object,
			required: true,
		},
	},
	computed: {
		radarChartSeries() {
			if (this.result.shipName == "Ovation of the Seas") {
				return [{
						name: "Crowd Scoring",
						data: [0.88, 0.81, 0.78, 0.83, 0.61, 0.81, 0.84].map((v) => 100 * v),
					}];
			} else {
				return [{
            name: "Crowd Scoring",
            data: [0.88, 0.85, 0.73, 0.85, 0.67, 0.77, 0.81].map((v) => 100 * v)
        }];
			}
		},
		tops() {
			if (this.result.shipName == "Ovation of the Seas") {
				return [
					{
						label: "Guest Relation",
						score: 0.94,
						reviews: 35,
					},
					{
						label: "General Service",
						score: 0.85,
						reviews: 765,
					},
					{
						label: "Dinner Service",
						score: 0.72,
						reviews: 206,
					},
				];
			} else {
				return [
					{
						label: "Bar Service",
						score: 0.81,
						reviews: 45,
					},
					{
						label: "General Service",
						score: 0.79,
						reviews: 980,
					},
					{
						label: "Cabin Service",
						score: 0.77,
						reviews: 76,
					},
				];
			}
		},
		flops() {
			if (this.result.shipName == "Ovation of the Seas") {
				return [
					{
						label: "Check-In",
						score: 0.405,
						reviews: 56,
					},
					{
						label: "Cabin Service",
						score: 0.425,
						reviews: 114,
					},
					{
						label: "Bar Service",
						score: 0.55,
						reviews: 68,
					},
				];
			} else {
				return [
					{
						label: "Check-In",
						score: 0.375,
						reviews: 56,
					},
					{
						label: "Spa",
						score: 0.45,
						reviews: 130,
					},
					{
						label: "Childcare",
						score: 0.475,
						reviews: 45,
					},
				];
			}
		},
	},
};
</script>
